<template>
  <nav class="p-0 text-left">
    <folder-dropdown-share v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-edit v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-add-favourite v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-hide-publish v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-move v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-copy v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-trash v-if="!trash" :item="item" @onselect="close" />
    <folder-dropdown-restore v-if="trash" :item="item" @onselect="close" />
    <folder-dropdown-delete-permanently v-if="trash" :item="item" @onselect="close" />
  </nav>
</template>

<script>
export default {
  emits: ['onselect'],
  props: {
    item: Object,
    trash: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('onselect')
    }
  }
}
</script>

<style lang="scss" scoped></style>
